import { FC, useState } from 'react';
import { Col, Form, Row, Select } from 'antd';

import AiRequest from 'components/shared/AiRequest';

const Requests: FC = () => {
  const [status, setStatus] = useState<number>();

  return (
    <>
      <Form size="large" layout="vertical">
        <Row>
          <Col md={6} xs={24}>
            <Form.Item label="Status">
              <Select
                value={status}
                onChange={v => setStatus(v)}
                options={[
                  {
                    label: 'Submitted',
                    value: 1
                  },
                  {
                    label: 'Not Submitted',
                    value: 0
                  }
                ]}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <AiRequest status={status} />
    </>
  );
};

export default Requests;
